import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const rawHandle = localStorage.getItem("handle");
  const handle = rawHandle ? JSON.parse(rawHandle) : null;
  return handle?.token ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;
